import { Cycles } from '../api';

import { AsyncFunction } from './types';
import { CycleType } from '../data/types';

export const fetchCycles: AsyncFunction<string, CycleType[]> = async (jwtToken: string) => {
  return await Cycles.custom.getActiveCycles({ token: jwtToken });
};
